import type { Editor } from '@tiptap/core';
import { NODE_NAMES, NODE_TAGS } from '@confinion/confideck-shared';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import selectionHasNode from './selectionHasNode.helper';
import { BLOCK_NODE_NAME } from '../tiptap/nodes/block/constants';
import { INLINE_BLOCK_NODE_NAME } from '../tiptap/nodes/inlineBlock/constants';
import { LITERATURE_CITATION_NODE_NAME } from '../tiptap/nodes/literatureCitation/constants';
import { REFERENCE_NODE_NAME } from '../tiptap/nodes/reference/constants';

// The content block editor has no node for these, so it would drop them without a word.
const UNSUPPORTED_NODE_NAMES = new Set([
  INLINE_BLOCK_NODE_NAME,
  REFERENCE_NODE_NAME,
  LITERATURE_CITATION_NODE_NAME,
  BLOCK_NODE_NAME,
]);
// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/documents/src/checkBlockContent.ts
const UNSUPPORTED_TAGS = [
  NODE_TAGS.inlineBlock,
  NODE_TAGS.reference,
  NODE_TAGS.literatureCitation,
  NODE_TAGS.reusableBlock,
  NODE_NAMES.templateFieldInline,
  NODE_NAMES.templateFieldBlock,
  NODE_NAMES.templateFieldDropdown,
];
export const UNSUPPORTED_BLOCK_CONTENT_MESSAGE = `${TERMINOLOGY.block.upper} cannot contain a ${TERMINOLOGY.inlineBlock.lower}, other ${TERMINOLOGY.block.lower}, a ${TERMINOLOGY.reference.lower}, a ${TERMINOLOGY.literature.lower} citation or a template field yet.`;

export const UNSUPPORTED_BLOCK_PASTE_MESSAGE = `This paste leaves out any ${TERMINOLOGY.inlineBlock.lower}, other ${TERMINOLOGY.block.lower}, ${TERMINOLOGY.reference.lower} or ${TERMINOLOGY.literature.lower} citation, and turns template fields into plain text. ${TERMINOLOGY.block.upper} cannot contain them yet.`;

export const selectionHasUnsupportedBlockNode = (editor: Editor): boolean =>
  selectionHasNode(editor, UNSUPPORTED_NODE_NAMES);

export const htmlHasUnsupportedBlockNode = (html: string): boolean =>
  new DOMParser().parseFromString(html, 'text/html').querySelector(UNSUPPORTED_TAGS.join(', ')) !== null;
